export enum HazardSources {
  Provider = 'provider',
  Provider2 = 'provider2',
  Provider3 = 'provider3',
  Provider4 = 'provider4',
  Provider6 = 'provider6',
  Provider7 = 'provider7',
  Provider8 = 'provider8',
  Provider9 = 'provider9',
}
